import React from "react";

import AddLoan from "../../components/expense/add/AddLoan";
import DialogBox from "../../components/UI/DialogBox";
import { Add_EXPENSE } from "../../api/allApi_List";
import { handleErrMessage } from "../../functions/handleErrMessage";
import usePostData from "../../CustomHooks/useAxios/usePostData";
import MainPageLayout from "../../layout/MainPageLayout";
import { prepareFormData } from "../../functions/prepareFormData";

const AddLoanPage = () => {
  const { executePost, loading, formError, successResponse, setFormError } =
    usePostData();

  // execute post api
  const sendData = async (data, reset) => {
    // send data into form data
    const formData = prepareFormData(data);
    //API calling
    executePost(formData, Add_EXPENSE, reset);
  };

  return (
    <MainPageLayout headerConfig={{ title: "Add Loan" }}>
      <AddLoan
        sendData={sendData}
        loading={loading}
        successResponse={successResponse}
      />
      {formError && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(formError)}
          closeAction={() => setFormError("")}
        />
      )}
    </MainPageLayout>
  );
};

export default AddLoanPage;
